import React, { useEffect, useState } from "react";
import { DeleteForever } from "@mui/icons-material";
import { toast } from "react-toastify";
import SimpleModal from "../../../../components/SimpleModal/SimpleModal";
import { Colors } from "../../../../constants/Colors";
import { deleteVehicleEffect } from "../../../../stores/FleetsStore/FleetsStore.effects";
import { Fleet } from "../../../../types/fleets.types";

interface Props {
  fleet: Fleet;
}

const DeleteFleet: React.FC<Props> = ({ fleet }: Props) => {
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    if (!open) return;

    const unsubscribeDone = deleteVehicleEffect.doneData.watch(() => {
      toast.success("Frota deletada com sucesso!");
      setOpen(false);
    });
    const unsubscribeFail = deleteVehicleEffect.fail.watch(({ error }: any) => {
      console.log("Error Delete Fleet", error);
      toast.error("Erro ao deletar frota!");
    });

    return () => {
      unsubscribeFail();
      unsubscribeDone();
    };
  }, [open]);

  const handleDelete = () => {
    deleteVehicleEffect(fleet.id);
  };

  return (
    <SimpleModal
      open={open}
      setOpen={setOpen}
      Component={
        <DeleteForever
          sx={{
            color: Colors.secondary[100],
            ":hover": { opacity: "70%" },
            cursor: "pointer",
          }}
        />
      }
      onConfirm={handleDelete}
      title="Deletar"
      text="Confirma deletar esta frota?"
      confirmText="Deletar"
      cancelText="Cancelar"
    />
  );
};

export default DeleteFleet;
